import styled from 'styled-components';

export const StyledListWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledEmptyContent = styled.div`
  padding: 2rem 1rem;
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colorSurfaceVariant};
`;

export const StyledListContainer = styled.div`
  width: 360px;
  overflow: hidden;
`;

export const LIST_HEIGHT = 440;
